import { isArray, filter, first, includes, keys } from 'lodash';
import { determineLocale, expandLocales } from './helpers';

function getDomain(locale, translations) {
  const locales = expandLocales(locale);
  const domain = first(
    filter(translations, (textdomain, localeKey) => includes(locales, localeKey)),
  );

  if (!domain) {
    throw new Error(`Invalid locale: ${locale}. Configured: ${keys(translations)}`);
  }

  return domain;
}

export default class Localization {
  locale = 'en-US';

  constructor(translations = {}, textdomain = 'default') {
    this.locale = determineLocale();
    this.translations = translations;
    this.textdomain = textdomain;
  }

  setLocale = (locale) => {
    this.locale = locale;
  };

  getTextDomain = () => {
    return this.textdomain;
  };

  gettext = (msgid) => {
    const domain = getDomain(this.locale, this.translations);
    const translated = domain.gettext(msgid);
    const value = isArray(translated) ? first(filter(translated, Boolean)) : translated;
    return value || msgid;
  };

  xgettext = (msgid, context) => {
    const domain = getDomain(this.locale, this.translations);
    const translated = domain.xgettext(msgid, context);
    const value = isArray(translated) ? first(filter(translated, Boolean)) : translated;
    return value || msgid;
  };

  ngettext = (singular, plural, n) => {
    const domain = getDomain(this.locale, this.translations);
    return domain.ngettext(singular, plural, n);
  };

  nxgettext = (singular, plural, n, context) => {
    const domain = getDomain(this.locale, this.translations);
    return domain.nxgettext(singular, plural, n, context);
  };
}
